/* eslint-disable no-nested-ternary */
import { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import Router from 'next/router';

import _ from 'lodash';

import getSlug from 'speakingurl';

import { ArrowBack, ArrowForward } from '@mui/icons-material';

import { IconButton } from '@mui/material';

import { Label, FadeInAnimation } from '../shared';

import Carousel from '../carousel/carousel.component';

const BuildingCarousel = (props) => {

    const { buildings, cityName, cityId, isBuildings, margintop } = props;

    const roomTypes = _.map(props.roomTypes, (roomType) => roomType);    

    const [isError, setIsError] = useState(false);

    const [isMounted, setMounted] = useState(false);

    const responsive = {
        desktop: {
            breakpoint: { 
                max: 3000, 
                min: 1024 
            },
            items: 4,
        },
        mobile: {
            breakpoint: {
                max: 464,
                min: 0
            },
            items: 1,
        },
        tablet: {
            breakpoint: {
                max: 1024,
                min: 464
            },
            items: 2,
        }
    };

    useEffect(() => {
        setMounted(true);
    },[]);

    const onBuildingSelect = (buildingName, buildingId) => {
        const selectedBuilding = getSlug(buildingName);
        Router.push(`/buildings/${selectedBuilding}/${buildingId}`);
    };

    const getLowestStartingPrice = (buildingId) => {
        let filteredRoomTypes = [];
        if (isBuildings) {
            _.forEach(roomTypes, (roomType) => {
                _.forEach(_.get(roomType, 'ids'), (id) => {
                    if (
                        roomType.billingModelAbbreviation !== 'day' &&
                        _.get(id, 'buildingId') === buildingId
                    ) {
                        filteredRoomTypes.push(roomType);
                    }
                    return null;
                });
            });
        } else {
            filteredRoomTypes = _.filter(roomTypes, (roomType) => {
                if (
                    roomType.buildingId === buildingId &&
                    roomType.billingModelAbbreviation !== 'day'
                ) {
                    return roomType;
                }
                return null;
            });
        }

        const sortedRoomTypes = _.sortBy(filteredRoomTypes, [(roomType) => roomType.startingPrice]);

        if (sortedRoomTypes) {
            return sortedRoomTypes[0];
        }
        return null;
    };

    const IndividualBuildingImage = ({ src, alt, onClick, id }) => {
        return (
            <img
                src={src}
                alt={alt}
                width="100%"
                height="100%"
                id={id}
                onClick={onClick}
                className='building-carousel-image'
            />
        );
    };

    const renderCarouselItem = () => {

        return _.map(buildings, (building, index) => {

            if (_.get(building, 'address.cityId') === cityId) {
                
                const buildingName = _.get(building, 'name');
                const buildingId = _.get(building, 'id');
                const bookableSpace = _.get(building, 'bookableSpaces');
                const cheapestRoom = getLowestStartingPrice(buildingId);
                const lowestPrice = _.get(cheapestRoom, 'startingPrice');
                const billingModelDescription = _.get(cheapestRoom, 'billingModelDescription');
                const originalImgSrc =  _.get(building, 'images[0]');                

                return (
                    
                        <div index={index} key={index} className="building-carousel-inner">

                            <div className='building-carousel-image-container'>
                                <IndividualBuildingImage
                                    src={originalImgSrc}
                                    alt={`${buildingName}-building`}
                                    id={`${buildingName}-carousel-button`}
                                    onClick={() => onBuildingSelect(buildingName, buildingId)}                                    
                                />
                            </div>

                            <p
                                className="building-carousel-paragraph city-name">
                                {buildingName}
                            </p>

                            <h6>
                                {_.get(building, 'address.addressLine2')},{' '}
                                {_.get(building, 'city') || cityName}
                            </h6>

                            <div className='building-carousel-details-container'>

                                <h6>
                                    From{' '}
                                    <strong>
                                        R{lowestPrice} {billingModelDescription}
                                    </strong>
                                </h6>

                                <Label small type="white">
                                    {bookableSpace} spaces
                                </Label>

                            </div>

                        </div>
                    
                );
            }
            return null;
        });
    };

    const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
        return (
            <div id="building-carousel-button-group" className="building-carousel-button-container">
                <IconButton
                    className="building-carousel-back-button" onClick={() => previous()}
                    aria-label="Back"                 
                >
                    <ArrowBack className="building-carousel-arrow-icon" />
                </IconButton>

                <IconButton
                    className="building-carousel-next-button" onClick={() => next()}
                    aria-label="Next"
                >
                    <ArrowForward className="building-carousel-arrow-icon" />
                </IconButton>
            </div>
        );
    };     

    const renderCarousel = () => {

        if(!isMounted) return null;

        let buildingCount = 0;        

        _.forEach(buildings, (building) => {
            if (_.get(building, 'address.cityId') === cityId) {
                buildingCount += 1;
            }
        }); 

        if (buildingCount < 2) {
            return null;
        }

        return (

            <div id="building-carousel">

                <FadeInAnimation>

                    <div className='building-carousel-wrapper'>

                        <p className='building-carousel-header'>
                            Our Buildings in {cityName}
                        </p>

                        <Carousel
                            responsive={responsive}
                            showDots={false}
                            arrows={false}
                            slidesToSlide={1}
                            infinite={true}
                            draggable={false}
                            autoPlay={true}
                            customCarouselItemWidth={371.156}
                            renderButtonGroupOutside={true}
                            customButtonGroup={<ButtonGroup />}
                            >
                            {renderCarouselItem()}
                        </Carousel>

                    </div>

                </FadeInAnimation>

            </div>
        );
    };

    return <>{renderCarousel()}</>;
};

export default BuildingCarousel;

BuildingCarousel.propTypes = {
    buildings: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    roomTypes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    margintop: PropTypes.number,
    cityName: PropTypes.string,
    cityId: PropTypes.string,
    isBuildings: PropTypes.bool,
};
